/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import {
	required,
	numericality,
	addValidator,
	format,
} from "redux-form-validators";

import Button from "../../../components/Button";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { InputField } from "../../../components/UIform/inputField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ModalComponent from "../../../components/ModalComponent";
import CustomInputTextarea from "../../../components/UIform/inputTextarea";
import CustomizedInputs from "../../../components/UIform";
import Loading from "../../../components/Loading";
import Chip from "@material-ui/core/Chip";
import Popover from "../../../components/Popover";

import CalendarPeriod from "./CalendarPeriod";
import { useTranslation } from "react-i18next";

const promocodesValidator = addValidator({
	defaultMessage: "Ошибка валидации",
	validator: function (options, value, allValues) {
		return (options.lowerCase ? /^[a-z0-9A-Z]+$/ : /^[a-z]+$/i).test(value);
	},
});

let EditModalPromocodesForm = (props) => {
	const classes = useStyles();
	const isMin600 = useMediaQuery("(max-width: 599px)");

	const { t } = useTranslation();

	const [openModal, setOpenModal] = useState(false);
	const [isSubmit, setIsSubmit] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const [data, setData] = useState(null);
	const [checked, setChecked] = useState(null);

	const [noPromocodeForProductsIds, setNoPromocodeForProductsIds] =
		useState(null);
	const [noPromocodeForCategoriesIds, setNoPromocodeForCategoriesIds] =
		useState(null);
	const [idProducts, setIdProducts] = useState("");
	const [idCategories, setIdCategories] = useState("");

	useEffect(() => {
		setNoPromocodeForProductsIds(props.initialValues.noPromocodeForProductsIds);
		setNoPromocodeForCategoriesIds(
			props.initialValues.noPromocodeForCategoriesIds
		);
	}, []);

	const { handleSubmit, count, setCount } = props;

	const isPresent = count === 1;
	const isDiscount = count === 2;
	const isAmount = count === 3;

	const handleChange = (e) => {
		const name = e.target.name;

		if (name == "radioPresent" && count !== 1) setCount(1);
		if (name == "radioDiscount" && count !== 2) setCount(2);
		if (name == "radioAmount" && count !== 3) setCount(3);
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;

		if (name === "idProducts") {
			setIdProducts(value); // Обновляем локальное состояние при изменении
			return;
		}

		if (name === "idCategories") {
			setIdCategories(value);
			return;
		}

		setData({
			...data,
			parametr: value,
			type: count,
		});
	};

	const handleAddProduct = () => {
		const status = noPromocodeForProductsIds.find(
			(chip) => chip === idProducts
		);
		const isValue = idProducts.length > 0 ? true : false;

		if (status === undefined && isValue) {
			setNoPromocodeForProductsIds([...noPromocodeForProductsIds, idProducts]);
			setIdProducts("");
			props.change("idProducts", "");
		} else if (!isValue) {
			alert("Пустое поле");
		} else {
			alert(t("menu.duplicateId"));
		}
	};

	const handleDeleteProduct = (chipToDelete) => () => {
		const list = noPromocodeForProductsIds.filter(
			(chip) => chip !== chipToDelete
		);
		setNoPromocodeForProductsIds(list);
	};

	const handleAddCategory = () => {
		const status = noPromocodeForCategoriesIds.find(
			(chip) => chip === idCategories
		);
		const isValue = idCategories.length > 0 ? true : false;

		if (status === undefined && isValue) {
			setNoPromocodeForCategoriesIds([
				...noPromocodeForCategoriesIds,
				idCategories,
			]);
			setIdCategories("");
			props.change("idCategories", "");
		} else if (!isValue) {
			alert("Пустое поле");
		} else {
			alert(t("menu.duplicateId"));
		}
	};

	const handleDeleteCategory = (chipToDelete) => () => {
		const list = noPromocodeForCategoriesIds.filter(
			(chip) => chip !== chipToDelete
		);
		setNoPromocodeForCategoriesIds(list);
	};

	useEffect(() => {
		if (!checked) {
			setChecked(
				data.isUseDiscountIdsAllowed ? data.isUseDiscountIdsAllowed : false
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (isLoading && isSubmit && !openModal) {
			const { onSubmit, handleClose, dataForm, id } = props;

			let newDataForm = {};
			let newId = data.id.replace(/ /g, "");

			for (let key in dataForm) {
				const item = dataForm[key];

				if (id != key) newDataForm[key] = item;
			}

			let newData = {
				...newDataForm,
				[newId]: {
					...newDataForm[id],
					...data,
					isUseDiscountIdsAllowed: checked ? checked : false,
					noPromocodeForCategoriesIds,
					noPromocodeForProductsIds,
				},
			};

			console.log(newData);

			onSubmit(newData);

			handleClose();
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSubmit, isLoading, openModal]);

	const handleCloseModal = () => {
		setOpenModal(false);
		setIsSubmit(false);
	};

	const handleClickSubmit = () => {
		setOpenModal(false);
		setIsSubmit(true);
	};

	const submitForm = () => {
		const { valid } = props;

		if (valid) {
			setOpenModal(true);
			setIsLoading(true);
		}
	};

	const handleCheckboxChange = (e) => {
		const value = e.target.checked;

		if (checked !== value) {
			setChecked(value);
		}
	};

	const handleInputFieldChange = (e) => {
		const { name, value } = e.target;
		// console.log('props', props);

		// console.log('name', e.target.value);
		// console.log('data', data);

		setData({
			...data,
			[name]: name === "orderLimit" ? +value : value,
		});
	};

	let initialValues = {};
	const { id, dataForm } = props;
	const product = dataForm[id];

	if (product) {
		const {
			isAvailable,
			type,
			parametr,
			title,
			description,
			begin,
			end,
			discountId,
			isUseDiscountIdsAllowed,
			orderLimit,
		} = product;

		if (type === 1 && count === 1) initialValues["present"] = parametr;
		if (type === 2 && count === 2) initialValues["discount"] = parametr;
		if (type === 3 && count === 3) initialValues["amount"] = parametr;

		if (!data && type && count) {
			setData({
				isAvailable,
				begin,
				description,
				discountId,
				end,
				id,
				parametr,
				title,
				type,
				isUseDiscountIdsAllowed,
				noPromocodeForCategoriesIds,
				noPromocodeForProductsIds,
				orderLimit,
			});
		}
	}

	return (
		<>
			<ModalComponent
				title={t("modals.confirm")}
				description={t("modals.confirmSave")}
				open={openModal}
				handleClose={handleCloseModal}
				handleClickSubmit={handleClickSubmit}
			/>
			<form
				onSubmit={handleSubmit}
				autoComplete="off"
				initialValues={initialValues}
			>
				<div className={classes.discountRadios}>
					<div
						className={classes.discountInput}
						style={{ height: isPresent ? "100%" : "57px" }}
					>
						<label htmlFor="radioPresent" className={classes.discountInputWrap}>
							<Typography className={classes.discountTitle}>
								{t("sales.gift")}
							</Typography>
							<Field
								id="radioPresent"
								className={classes.discountRadio}
								name="radioPresent"
								component="input"
								type="radio"
								value={isPresent ? "radioPresent" : ""}
								checked={isPresent}
								onChange={handleChange}
							/>
						</label>
						{isPresent && (
							<div className={classes.discountHidden}>
								<InputField
									title={t("sales.product")}
									placeholder={t("sales.enterProduct")}
									name="present"
									type="text"
									onChange={handleInputChange}
									validate={[required({ msg: t("modals.requiredField") })]}
								/>
							</div>
						)}
					</div>
					<div
						className={classes.discountInput}
						style={{ height: isDiscount ? "100%" : "57px" }}
					>
						<label
							htmlFor="radioDiscount"
							className={classes.discountInputWrap}
						>
							<Typography className={classes.discountTitle}>
								{t("sales.sales")}
							</Typography>
							<Field
								id="radioDiscount"
								className={classes.discountRadio}
								name="radioDiscount"
								component="input"
								type="radio"
								value={isDiscount ? "radioDiscount" : ""}
								checked={isDiscount}
								onChange={handleChange}
							/>
						</label>
						{isDiscount && (
							<div className={classes.discountHidden}>
								<InputField
									title={t("sales.salePercent")}
									placeholder={t("sales.enterSalePercent")}
									name="discount"
									onChange={handleInputChange}
									validate={[
										required({ msg: t("modals.requiredField") }),
										numericality({
											int: true,
											"<=": 100,
											msg: {
												"<=": `${t("sales.less")} ${count}`,
												int: t("sales.int"),
											},
										}),
									]}
								/>
							</div>
						)}
					</div>
					<div
						className={classes.discountInput}
						style={{ height: isAmount ? "100%" : "57px" }}
					>
						<label htmlFor="radioAmount" className={classes.discountInputWrap}>
							<Typography className={classes.discountTitle}>
								{t("sales.sum")}
							</Typography>
							<Field
								id="radioAmount"
								className={classes.discountRadio}
								name="radioAmount"
								component="input"
								type="radio"
								value={isAmount ? "radioAmount" : ""}
								checked={isAmount}
								onChange={handleChange}
							/>
						</label>
						{isAmount && (
							<div className={classes.discountHidden}>
								<InputField
									title={t("sales.saleSum")}
									placeholder={t("sales.enterSaleSum")}
									name="amount"
									onChange={handleInputChange}
									validate={[
										required({ msg: t("modals.requiredField") }),
										numericality({
											int: true,
											msg: {
												int: t("sales.int"),
											},
										}),
									]}
								/>
							</div>
						)}
					</div>
					<div className={classes.otherFields}>
						<div className={classes.code}>
							<CalendarPeriod
								data={data}
								setData={setData}
								startDate={true}
								secondDate={false}
							/>
							<CalendarPeriod
								data={data}
								setData={setData}
								startDate={false}
								secondDate={true}
							/>
							<InputField
								title={t("promocodes.code")}
								placeholder={t("promocodes.enterCode")}
								className={classes.otherInput}
								name="id"
								type="text"
								onChange={handleInputFieldChange}
								validate={
									// eslint-disable-next-line no-sequences
									[
										required({ msg: t("modals.requiredField") }),
										format({
											with: /^[a-z0-9A-Z]+$/,
											msg: t("modals.errorData"),
										}),
									]
								}
							/>
							<div style={{ margin: "5px 0 0", color: "red" }}>
								*{t("promocodes.caseSensitiveInfo")}
							</div>

							<InputField
								title={t("promocodes.minOrder")}
								placeholder={t("promocodes.enterMinOrder")}
								name="orderLimit"
								onChange={handleInputFieldChange}
								className={classes.otherInput}
								validate={[
									required({ msg: t("modals.requiredField") }),
									numericality({
										int: true,
										">=": 0,
										msg: {
											"<=": `${t("sales.less")} ${count}`,
											int: t("sales.int"),
										},
									}),
								]}
							/>

							<InputField
								title={t("promocodes.name")}
								placeholder={t("promocodes.enterName")}
								className={classes.otherInput}
								name="title"
								type="text"
								onChange={handleInputFieldChange}
								validMsg={id ? t("modals.requiredField") : ""}
							/>
							<InputField
								title={t("promocodes.description")}
								component={CustomInputTextarea}
								placeholder={t("promocodes.enterDescription")}
								className={classes.textarea}
								name="description"
								onChange={handleInputFieldChange}
								validMsg={id ? t("modals.requiredField") : ""}
							/>
						</div>
						<FormControlLabel
							control={
								<Checkbox
									className={classes.checkbox}
									checked={checked}
									onChange={handleCheckboxChange}
									name="checkedA"
									color="primary"
								/>
							}
							label={t("promocodes.applyForPromocodes")}
						/>
					</div>
				</div>
				<div className={classes.categoriesWrap}>
					<div className={classes.headerWrapper}>
						<Typography className={classes.typography}>
							{t("sales.noSaleCategories")}
						</Typography>
						<Popover className={classes.popover} title="" hiddenTitle="-" />
					</div>
					<div className={classes.chips}>
						<ul className={classes.chipsList}>
							{noPromocodeForCategoriesIds?.slice(1).map((data, index) => {
								return (
									<li key={index} className={classes.chipsListLi}>
										<Chip
											label={data}
											onDelete={handleDeleteCategory(data)}
											className={classes.chip}
										/>
										{isMin600 && <hr className={classes.hr} />}
									</li>
								);
							})}
						</ul>
					</div>
					<div className={classes.wrapper}>
						<Field
							name="idCategories"
							component={CustomizedInputs}
							className={classes.inputField}
							type="text"
							placeholder={t("menu.enterCategory")}
							label=""
							rows={"1"}
							disabled={props.loadStatus ? true : false}
							value={idCategories}
							onChange={handleInputChange}
						/>

						<div>
							<Button
								className={classes.button}
								text={
									props.loadStatus ? (
										<Loading size={22} color={"#fff"} />
									) : (
										t("buttons.addList")
									)
								}
								disabled={props.loadStatus ? true : false}
								handleClick={handleAddCategory}
							/>
						</div>
					</div>
				</div>
				<div className={classes.categoriesWrap}>
					<div className={classes.headerWrapper}>
						<Typography className={classes.typography}>
							{t("sales.noSaleProducts")}
						</Typography>
						<Popover className={classes.popover} title="" hiddenTitle="-" />
					</div>
					<div className={classes.chips}>
						<ul className={classes.chipsList}>
							{noPromocodeForProductsIds?.slice(1).map((data, index) => {
								return (
									<li key={index} className={classes.chipsListLi}>
										<Chip
											label={data}
											onDelete={handleDeleteProduct(data)}
											className={classes.chip}
										/>
										{isMin600 && <hr className={classes.hr} />}
									</li>
								);
							})}
						</ul>
					</div>
					<div className={classes.wrapper}>
						<Field
							name="idProducts"
							component={CustomizedInputs}
							className={classes.inputField}
							type="text"
							placeholder={t("menu.enterProduct")}
							label=""
							rows={"1"}
							disabled={props.loadStatus ? true : false}
							value={idProducts}
							onChange={handleInputChange}
						/>

						<div>
							<Button
								className={classes.button}
								text={
									props.loadStatus ? (
										<Loading size={22} color={"#fff"} />
									) : (
										t("buttons.addList")
									)
								}
								disabled={props.loadStatus ? true : false}
								handleClick={handleAddProduct}
							/>
						</div>
					</div>
				</div>
				<div className={classes.buttonWrapper}>
					<Button
						fontSize={22}
						color={"#fff"}
						className={classes.button}
						text={t("buttons.save")}
						handleClick={() => submitForm(handleSubmit)}
					/>
				</div>
			</form>
		</>
	);
};

const useStyles = makeStyles((theme) => ({
	dialogPaper: {
		width: "80%",
		maxWidth: 1057,
		padding: 24,
	},
	dialogTitle: {
		padding: 0,
		"& h2": {
			fontSize: 16,
			fontWeight: "normal",
			lineHeight: "25px",
		},
	},
	iconsWrapper: {
		display: "flex",
	},
	closeIcon: {
		marginRight: 16,
		color: "#476282",
		"&:hover": {
			color: "black",
			cursor: "pointer",
		},
	},
	buttonWrapper: {
		margin: "0 auto",
		marginTop: 30,
		textAlign: "center",
	},
	discountRadios: {
		marginTop: 30,
		[theme.breakpoints.down("600")]: {
			marginTop: 16,
		},
	},
	discountInput: {
		display: "flex",
		flexDirection: "column",
		height: 57,
		width: "100%",
		padding: "0 16px 16px 16px",
		marginBottom: 16,
		boxSizing: "border-box",

		boxShadow: "0px 14px 23px rgba(232, 228, 228, 0.5)",
		background: "white",
		borderRadius: 5,
	},
	discountTitle: {
		fontSize: 16,
		fontWeight: 500,
		lineHeight: "57px",
		color: "black",
	},
	discountInputWrap: {
		width: "100%",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		cursor: "pointer",
	},
	discountRadio: {
		margin: 0,
		cursor: "pointer",
	},
	discountHidden: {
		width: 328,
		[theme.breakpoints.down("600")]: {
			width: "100%",
		},
	},
	otherFields: {},
	code: {},
	textarea: {
		maxWidth: "327px",
		width: "100%",
		[theme.breakpoints.down("600")]: {
			maxWidth: "100%",
		},
		"& > div:before": {
			display: "none",
		},
		"& > div": {
			// width: '327px',
			marginTop: 8,
			resize: "none",
			// height: 103,
			border: "1px solid #DADCE0",
			borderRadius: "5px",
			padding: "11px 16px 11px 16px",
			boxSizing: "border-box",
			fontSize: 16,
			fontFamily: "Roboto, Helvetica, Arial, sans-serif",
			lineHeight: "24px",
			[theme.breakpoints.down("600")]: {
				width: "100%",
			},
		},
		"& > div:after": {
			display: "none",
		},
		"& > div.Mui-error": {
			border: "1px solid red;",
		},
		"&::-webkit-input-placeholder": {
			color: "#DADCE0",
			fontWeight: 400,
		},
		"&::textarea:-moz-placeholder": {
			color: "#DADCE0",
			fontWeight: 400,
		},
		"&::textarea::-moz-placeholder": {
			color: "#DADCE0",
			fontWeight: 400,
		},
		"&::textarea:-ms-input-placeholder": {
			color: "#DADCE0",
			fontWeight: 400,
		},
		"&::textarea::placeholder": {
			color: "#DADCE0",
			fontWeight: 400,
		},
	},
	otherInput: {
		width: "100%",
		marginTop: 8,
		"& input": {
			width: "100%",
			height: 45,
			border: "1px solid #DADCE0",
			borderRadius: "5px",
			padding: "11px 50px 11px 16px",
			boxSizing: "border-box",
		},
		"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
			content: "none",
		},
		"& .MuiInput-underline:after": {
			content: "none",
		},
		"& .MuiInput-underline:before": {
			content: "none",
		},
		"& .Mui-error input": {
			border: "1px solid red",
		},
	},
	otherInputDescription: {
		width: "100%",
		marginTop: 8,
		"& input": {
			width: "100%",
			height: 103,
			border: "1px solid #DADCE0",
			borderRadius: "5px",
			padding: "11px 50px 11px 16px",
			boxSizing: "border-box",
		},
		"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
			content: "none",
		},
		"& .MuiInput-underline:after": {
			content: "none",
		},
		"& .MuiInput-underline:before": {
			content: "none",
		},
		"& .Mui-error input": {
			border: "1px solid red",
		},
	},
	checkbox: {
		"&.MuiCheckbox-colorPrimary.Mui-checked": {
			color: "#326dff",
		},
		"&.MuiCheckbox-colorPrimary": {
			padding: 10,
		},
	},
	headerWrapper: {
		display: "flex",
		position: "relative",
		maxWidth: 438,
	},
	popover: {
		top: 2,
	},
	categoriesWrap: {
		marginTop: 24,
		padding: 16,
		minHeight: 132,

		border: "1px solid #DADCE0",
		boxSizing: "border-box",
		borderRadius: 5,
		background: "white",
	},
	typography: {
		fontSize: 18,
		fontWeight: 500,
		lineHeight: "21px",
		paddingRight: 20,
	},
	wrapper: {
		display: "flex",
		alignItems: "end",
		[theme.breakpoints.down("600")]: {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
		},
	},
	categoriesContent: {
		display: "flex",
		[theme.breakpoints.down("600")]: {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		},
	},
	inputField: {
		"& input": {
			width: 328,
			height: 45,
			border: "1px solid #DADCE0",
			borderRadius: "5px",
			padding: "11px 50px 11px 16px",
			boxSizing: "border-box",
		},
		"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
			content: "none",
		},
		"& .MuiInput-underline:after": {
			content: "none",
		},
		"& .MuiInput-underline:before": {
			content: "none",
		},
		"& .Mui-error input": {
			border: "1px solid red",
		},
		[theme.breakpoints.down("375")]: {
			"& > div > input": {
				width: "100%",
			},
		},
	},
	button: {
		marginTop: 0,
		marginLeft: 15,
		fontSize: 14,
		textTransform: "inherit",
		[theme.breakpoints.down("600")]: {
			marginTop: 16,
			marginLeft: 0,
		},
	},

	chipsList: {
		paddingLeft: 0,
		display: "flex",
		flexWrap: "wrap",
		[theme.breakpoints.down("600")]: {
			width: "100%",
			display: "flex",
			flexDirection: "column",
			"& > li > div": {
				width: "100%",
			},
			"& > li:last-child > hr": {
				display: "none",
			},
		},
	},
	chipsListLi: {
		listStyleType: "none",
		marginRight: 5,
		marginBottom: 5,
		[theme.breakpoints.down("600")]: {
			marginRight: 5,
		},
	},
	chip: {
		fontSize: 12,
		lineHeight: 1,
		color: "white",
		backgroundColor: "#326DFF",
		[theme.breakpoints.down("600")]: {
			display: "flex",
			justifyContent: "space-between",
			background: "#E0E9FF",
			color: "#326DFF",
			padding: "0 6px",
		},

		"&.MuiChip-deletable > .MuiChip-deleteIcon": {
			color: "rgba(255, 255, 255, .26)",
			[theme.breakpoints.down("600")]: {
				color: "rgba(255, 255, 255, 1)",
			},
		},
	},
	hr: {
		border: "1px dashed rgba(71, 98, 130, .25)",
		boxSizing: "border-box",
		marginLeft: "10px",
		marginRight: "10px",
	},
}));

const mapStateToProps = (state, props) => {
	let initialValues = {};

	const { id, count, dataForm } = props;

	const product = dataForm[id];

	if (product) {
		const {
			type,
			parametr,
			orderLimit,
			title,
			description,
			begin,
			end,
			discountId,
			noPromocodeForCategoriesIds,
			noPromocodeForProductsIds,
		} = product;

		if (type === 1 && count === 1) initialValues["present"] = parametr;
		if (type === 2 && count === 2) initialValues["discount"] = parametr;
		if (type === 3 && count === 3) initialValues["amount"] = parametr;

		initialValues["id"] = product.id;
		initialValues["discountId"] = discountId;
		initialValues["orderLimit"] = +orderLimit || +0;
		initialValues["title"] = title;
		initialValues["description"] = description;
		initialValues["begin"] = begin;
		initialValues["end"] = end;
		initialValues["noPromocodeForCategoriesIds"] = noPromocodeForCategoriesIds
			? noPromocodeForCategoriesIds
			: [];
		initialValues["noPromocodeForProductsIds"] = noPromocodeForProductsIds
			? noPromocodeForProductsIds
			: [];
	}

	return { initialValues };
};

EditModalPromocodesForm = connect(
	mapStateToProps,
	null
)(
	reduxForm({
		form: "EditModalForm",
		enableReinitialize: true,
	})(EditModalPromocodesForm)
);

export default EditModalPromocodesForm;
